import { Group, MantineTheme, Text } from "@mantine/core";
import { IconCalendarEvent, IconCalendarMinus, IconCalendarPlus } from "@tabler/icons-react";
import { ReactNode } from "react";

export function DiferenciasRutaInfoViewColumnsOverrides(theme: MantineTheme) {
    return {
        // Diferencia Tienda
        0: {
            render: (value: unknown) => {
                const val = (value as string);
                if (val.endsWith('*')) {
                    const result = val.replace('*', '').split('por');
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconCalendarEvent style={{ color: theme.colors.yellow[8], minWidth: "1.3rem" }} size="1.3rem" />
                        <Text truncate><del>{result[0]}</del> por {result[1]}</Text>
                    </Group>
                }
                if (val.endsWith('--')) {
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconCalendarMinus style={{ color: theme.colors.red[8], minWidth: "1.3rem" }} size="1.3rem" />
                        <Text truncate><del>{val.replace('--', '')}</del></Text>
                    </Group>
                }
                if (val.endsWith('+')) {
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconCalendarPlus style={{ color: theme.colors.green[8], minWidth: "1.3rem" }} size="1.3rem" />
                        <Text truncate>{val.replace('+', '')}</Text>
                    </Group>
                }
                return value as ReactNode;
            }
        },
        // Diferencia Lunes
        1: {
            render: (value: unknown) => {
                const val = (value as string);
                if (val.endsWith('*')) {
                    const result = val.replace('*', '').split('por');
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconCalendarEvent style={{ color: theme.colors.yellow[8], minWidth: "1.3rem" }} size="1.3rem" />
                        <Text truncate><del>{result[0]}</del> por {result[1]}</Text>
                    </Group>
                }
                return value as ReactNode;
            }
        },
        // Diferencia Martes
        2: {
            render: (value: unknown) => {
                const val = (value as string);
                if (val.endsWith('*')) {
                    const result = val.replace('*', '').split('por');
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconCalendarEvent style={{ color: theme.colors.yellow[8], minWidth: "1.3rem" }} size="1.3rem" />
                        <Text truncate><del>{result[0]}</del> por {result[1]}</Text>
                    </Group>
                }
                return value as ReactNode;
            }
        },
        // Diferencia Miércoles
        3: {
            render: (value: unknown) => {
                const val = (value as string);
                if (val.endsWith('*')) {
                    const result = val.replace('*', '').split('por');
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconCalendarEvent style={{ color: theme.colors.yellow[8], minWidth: "1.3rem" }} size="1.3rem" />
                        <Text truncate><del>{result[0]}</del> por {result[1]}</Text>
                    </Group>
                }
                return value as ReactNode;
            }
        },
        //// Diferencia Jueves
        4: {
            render: (value: unknown) => {
                const val = (value as string);
                if (val.endsWith('*')) {
                    const result = val.replace('*', '').split('por');
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconCalendarEvent style={{ color: theme.colors.yellow[8], minWidth: "1.3rem" }} size="1.3rem" />
                        <Text truncate><del>{result[0]}</del> por {result[1]}</Text>
                    </Group>
                }
                return value as ReactNode;
            }
        },
        //// Diferencia Viernes
        5: {
            render: (value: unknown) => {
                const val = (value as string);
                if (val.endsWith('*')) {
                    const result = val.replace('*', '').split('por');
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconCalendarEvent style={{ color: theme.colors.yellow[8], minWidth: "1.3rem" }} size="1.3rem" />
                        <Text truncate><del>{result[0]}</del> por {result[1]}</Text>
                    </Group>
                }
                return value as ReactNode;
            }
        },
        //// Diferencia Sábado
        6: {
            render: (value: unknown) => {
                const val = (value as string);
                if (val.endsWith('*')) {
                    const result = val.replace('*', '').split('por');
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconCalendarEvent style={{ color: theme.colors.yellow[8], minWidth: "1.3rem" }} size="1.3rem" />
                        <Text truncate><del>{result[0]}</del> por {result[1]}</Text>
                    </Group>
                }
                return value as ReactNode;
            }
        },
        // Diferencia Domingo
        7: {
            render: (value: unknown) => {
                const val = (value as string);
                if (val.endsWith('*')) {
                    const result = val.replace('*', '').split('por');
                    return <Group style={{ gap: '.5rem' }} noWrap>
                        <IconCalendarEvent style={{ color: theme.colors.yellow[8], minWidth: "1.3rem" }} size="1.3rem" />
                        <Text truncate><del>{result[0]}</del> por {result[1]}</Text>
                    </Group>
                }
                return value as ReactNode;
            }
        },
        // Estado
        //8: {
        //    render: (value: unknown) => {
        //        const val = (value as string);
        //        if (val === 'Sin cambios') {
        //            return <Group style={{ gap: '.5rem' }} noWrap>
        //                <IconCalendar style={{ color: theme.colors.blue[8], minWidth: "1.3rem" }} size="1.3rem" />
        //                <Text truncate>Sin cambios</Text>
        //            </Group>
        //        }
        //        return value as ReactNode;
        //    }
        //}
    }
}